import { CustomColumnGridConfig } from '../types'

const columnsConfig: CustomColumnGridConfig[] = [
  // מספר כ.מים → waterCard
  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'waterCard',
    headerName: 'מספר כ.מים',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  // מספר מד → meterNumber
  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'meterNumber',
    headerName: 'מספר מד',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  // מספר משלם → payerNumber
  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'payerNumber',
    headerName: 'מספר משלם',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  // כתובת → address
  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'address',
    headerName: 'כתובת',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  // ת.התחלה → opening
  // {
  //   width: 150,
  //   minWidth: 150,
  //   field: 'opening',
  //   headerName: 'ת.התחלה',
  //   filter: { type: 'search' },
  //   filterable: true,
  //   hideable: true,
  //   disableAggregation: true,
  // },

  // // ת.סיום → closing
  // {
  //   width: 150,
  //   minWidth: 150,
  //   field: 'closing',
  //   headerName: 'ת.סיום',
  //   filter: { type: 'search' },
  //   filterable: true,
  //   hideable: true,
  //   disableAggregation: true,
  // },

  // סוג מד → meterType
  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'meterType',
    headerName: 'סוג מד',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  // צריכת המים → consumption
  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'consumption',
    headerName: 'צריכת המים',
    filterSpec: { kind: 'number' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  // מספר מד ראשי → mainMeterNumber
  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'parentNumber',
    headerName: 'מספר מד ראשי',
    filterSpec: { kind: 'text' },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  // סוג מד ראשי → mainMeterType
  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'parentType',
    headerName: 'סוג מד ראשי',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },

  // ת.התחלה מד ראשי → mainStartDate
  // {
  //   width: 150,
  //   minWidth: 150,
  //   field: 'parentReadingTime',
  //   headerName: 'ת.התחלה מד ראשי',
  //   filter: { type: 'search' },
  //   filterable: true,
  //   hideable: true,
  //   disableAggregation: true,
  // },

  // ת.סיום מד ראשי → mainEndDate
  // {
  //   flex: 1,
  //   width: 150,
  //   minWidth: 150,
  //   field: 'mainEndDate',
  //   headerName: 'ת.סיום מד ראשי',
  //   filter: { type: 'search' },
  //   filterable: true,
  //   hideable: true,
  //   disableAggregation: true,
  // },

  // סטטוס מד ראשי → crm
  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'status',
    headerName: 'סטטוס מד ראשי',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
  {
    flex: 1,
    width: 150,
    minWidth: 150,
    field: 'parentStatus',
    headerName: 'סטאטוס מד הקר"מ הראשי',
    filterSpec: { kind: 'list', options: { source: 'rows' } },
    filterable: true,
    hideable: true,
    disableAggregation: true,
  },
]

export default columnsConfig
